// src/features/landing/presentation/components/PartnershipBenefitsSection.jsx
import React from "react";

export function PartnershipBenefitsSection() {
    const levels = [
        {
            id: 1,
            title: "채용 효율 극대화",
            color: "#5b8fd9",
            benefits: [
                "전문인력 즉시 활용",
                "3개월 보장제 실시",
                "맞춤 인력 지속 공급",
            ],
        },
        {
            id: 2,
            title: "정확한 인력 매칭 및 품질 보장",
            color: "#3d5fa8",
            benefits: ["체계적 역량 검증 시스템", "사전에 처우 협의 완결"],
        },
        {
            id: 3,
            title: "현장 부담 완화 및 운영 안정성 확보",
            color: "#2c4475",
            benefits: ["채용 관련 부담 제로화", "유연한 정산체계 운영"],
        },
    ];

    return (
        <section className="partnership-benefits-section">
            <div className="benefits-container">
                <h2 className="benefits-title">
                    <span className="title-brand">라이징브로커즈</span>와 파트너가 되어야
                    하는 <span className="title-emphasis">이유는 명확합니다.</span>
                </h2>

                <div className="benefits-stairs">
                    {levels.map((level, index) => (
                        <div
                            key={level.id}
                            className="stair-level"
                            style={{
                                "--level-color": level.color,
                                "--level-index": index,
                            }}
                        >
                            <div className="stair-content">
                                <h3 className="stair-title">{level.title}</h3>
                                <div className="stair-benefits">
                                    {level.benefits.map((benefit, idx) => (
                                        <div key={idx} className="benefit-item">
                                            <span className="benefit-number">
                                                {idx + 1}
                                            </span>
                                            <span className="benefit-text">{benefit}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="benefits-footer">
                    <p className="footer-tagline">
                        모두를 '성공'파트너로 만들어주는
                    </p>
                    <p className="footer-service">프리미엄 보험전문 헤드헌팅</p>
                    <p className="footer-brand">
                        <span className="brand-rising">Rising</span>{" "}
                        <span className="brand-brokers">Brokers</span>
                    </p>
                </div>
            </div>

            <style jsx>{`
                .partnership-benefits-section {
                    width: 100%;
                    min-height: 100vh;
                    background: linear-gradient(to bottom, #f0f2f5 0%, #e3e6ea 100%);
                    padding: 80px 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .benefits-container {
                    max-width: 1400px;
                    width: 100%;
                }

                .benefits-title {
                    font-size: 2.5rem;
                    font-weight: 700;
                    color: #2c3e50;
                    margin-bottom: 80px;
                    line-height: 1.4;
                }

                .title-brand {
                    color: #ff5722;
                }

                .title-emphasis {
                    color: #e63946;
                }

                .benefits-stairs {
                    display: flex;
                    align-items: flex-end;
                    gap: 0;
                    margin-bottom: 80px;
                    position: relative;
                    min-height: 500px;
                }

                .stair-level {
                    flex: 1;
                    background: var(--level-color);
                    border-radius: 12px 12px 0 0;
                    padding: 40px 30px;
                    color: white;
                    position: relative;
                    height: calc(200px + var(--level-index) * 150px);
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s ease;
                }

                .stair-level:hover {
                    transform: translateY(-10px);
                }

                .stair-content {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .stair-title {
                    font-size: 1.3rem;
                    font-weight: 700;
                    margin: 0;
                    line-height: 1.3;
                }

                .stair-benefits {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }

                .benefit-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 1rem;
                }

                .benefit-number {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.3);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.9rem;
                    font-weight: 700;
                    flex-shrink: 0;
                }

                .benefit-text {
                    line-height: 1.4;
                }

                .benefits-footer {
                    text-align: left;
                    padding: 0 30px;
                }

                .footer-tagline {
                    font-size: 1rem;
                    color: #e63946;
                    margin: 0 0 8px 0;
                    font-weight: 500;
                }

                .footer-service {
                    font-size: 1.1rem;
                    color: #e63946;
                    margin: 0 0 12px 0;
                    font-weight: 600;
                }

                .footer-brand {
                    font-size: 2rem;
                    font-weight: 700;
                    margin: 0;
                }

                .brand-rising {
                    color: #ff5722;
                }

                .brand-brokers {
                    color: #2c3e50;
                }

                @media (max-width: 1024px) {
                    .benefits-title {
                        font-size: 2rem;
                    }

                    .stair-level {
                        padding: 30px 20px;
                    }

                    .stair-title {
                        font-size: 1.1rem;
                    }

                    .benefit-item {
                        font-size: 0.9rem;
                    }
                }

                @media (max-width: 768px) {
                    .benefits-title {
                        font-size: 1.6rem;
                        margin-bottom: 40px;
                    }

                    .benefits-stairs {
                        flex-direction: column;
                        align-items: stretch;
                        min-height: auto;
                        gap: 20px;
                    }

                    .stair-level {
                        height: auto !important;
                        border-radius: 12px;
                        padding: 25px 20px;
                    }

                    .stair-title {
                        font-size: 1rem;
                    }

                    .benefit-item {
                        font-size: 0.85rem;
                    }

                    .footer-brand {
                        font-size: 1.5rem;
                    }
                }
            `}</style>
        </section>
    );
}
